var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("c-tab", {
        ref: "patrolTab",
        attrs: {
          type: "horizon",
          inlineLabel: true,
          dense: true,
          tabItems: _vm.tabItems,
        },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function (tab) {
              return [
                _c(tab.component, {
                  key: tab.key,
                  tag: "component",
                  attrs: {
                    popupParam: _vm.popupParam,
                    patrol: _vm.patrol,
                    eventScroll: _vm.eventScroll,
                    resultItems: _vm.resultItems,
                    colorItemse: _vm.colorItems,
                    child: _vm.child,
                  },
                  on: {
                    "update:popupParam": function ($event) {
                      _vm.popupParam = $event
                    },
                    "update:popup-param": function ($event) {
                      _vm.popupParam = $event
                    },
                    "update:patrol": function ($event) {
                      _vm.patrol = $event
                    },
                    "update:eventScroll": function ($event) {
                      _vm.eventScroll = $event
                    },
                    "update:event-scroll": function ($event) {
                      _vm.eventScroll = $event
                    },
                    "update:resultItems": function ($event) {
                      _vm.resultItems = $event
                    },
                    "update:result-items": function ($event) {
                      _vm.resultItems = $event
                    },
                    "update:colorItemse": function ($event) {
                      _vm.colorItems = $event
                    },
                    "update:color-itemse": function ($event) {
                      _vm.colorItems = $event
                    },
                    "update:child": function ($event) {
                      _vm.child = $event
                    },
                    closePopup: _vm.closePopup,
                    transInfo: _vm.transInfo,
                    research: _vm.research,
                  },
                }),
              ]
            },
          },
        ]),
        model: {
          value: _vm.tab,
          callback: function ($$v) {
            _vm.tab = $$v
          },
          expression: "tab",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }